type Percentage = `${number}%`;
// Rating logic helper function
export const generateStarRating = (rating: number, maxStars: number = 5): Percentage[] => {
  const stars: Percentage[] = [];
  const averageStar = Math.round(rating * 10) / 2;

  const fullStars = Math.floor(averageStar);
  const fraction = averageStar - fullStars;
  const partialFill = Math.round(fraction * 100);

  for (let i = 0; i < maxStars; i++) {
    if (i < averageStar && i !== fullStars) {
      stars.push('100%');
    } else if (partialFill && i === fullStars) {
      stars.push(`${partialFill}%`);
    } else {
      stars.push('0%');
    }
  }
  return stars;
};
